import * as React from "react";

export interface SummaryNode {
    node: React.ReactNode;
    type: "placeholder" | "summary" | "default";
}

export default class Summary {
    static placeholder(node: React.ReactNode): SummaryNode {
        return {
            node,
            type: "placeholder"
        };
    }

    static default(node: React.ReactNode): SummaryNode {
        return {
            node,
            type: "default"
        };
    }

    static summary(node: React.ReactNode): SummaryNode {
        return {
            node,
            type: "summary"
        };
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/form/Sections/Summary.tsx